// @flow
import waitForAnalytics from './wait'

export default function page(...args: Array<any>) {
  waitForAnalytics(() => {
    if (process.env.NODE_ENV === 'development') {
      console.log('page called with', ...args) // eslint-disable-line no-console
    }

    window.analytics.page(...args)
  })
}
